import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    ActionsServiceModuleName,
    AngularJsSliderModuleName,
    AnimateModuleName,
    BranchServiceModuleName,
    CUSTOMER_PROFILE_MODULE_NAME,
    CustomerServiceModuleName,
    CustomersModuleName,
    CustomerSubscriptionModuleName,
    DirectMailerLogsModuleName,
    DragularModuleName,
    DynamicOrderingModuleName,
    EmployeeAutocompleteModuleName,
    FilterComponentsModuleName,
    LoggingModuleName,
    LqbPricerLogModuleName,
    LqbPricerParamsServiceModuleName,
    ManualImportModuleName,
    NAVIGATABLE_MODULE_NAME,
    NgMessagesModule,
    SortablePaginationModuleName,
    UserServiceModuleName,
    VAccordionModuleName,
    WebSocketProviderModuleName
} from "../utils/names/optionalModuleNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {ManualImportControllerName} from "../utils/names/controllerNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const ManualImportModuleConfiguration = new RestrictedRouteModuleConfiguration(
    UserGranredAuthorityName.MANUAL_IMPORT,
    [
        UserGranredAuthorityName.MANUAL_IMPORT,
        SortablePaginationModuleName,
        CustomerServiceModuleName,
        CustomersModuleName,
        AngularJsMaterialModuleName,
        WebSocketProviderModuleName,
        UserServiceModuleName,
        CUSTOMER_PROFILE_MODULE_NAME,
        CustomerSubscriptionModuleName,
        NAVIGATABLE_MODULE_NAME,
        VAccordionModuleName,
        AnimateModuleName,
        LoggingModuleName,
        DirectMailerLogsModuleName,
        ActionsServiceModuleName,
        NgMessagesModule,
        EmployeeAutocompleteModuleName,
        FilterComponentsModuleName,
        BranchServiceModuleName,
        AngularJsSliderModuleName,
        DynamicOrderingModuleName,
        DragularModuleName,
        //this is dumb
        //todo find where it came from and move
        LqbPricerLogModuleName,
        LqbPricerParamsServiceModuleName
    ],
    [
        ["/manual-import", {
            template: require("./route/manual-import.html"),
            controller: ManualImportControllerName
        }]
    ],
    [
        new NavigationItem({
            title: 'Import',
            href: '#!manual-import',
            accessRole: [NavigationAccessRoles.ROLE_ADMIN],
            activeFunction: routeName => routeName.indexOf("manual-import") !== -1
        })
    ],
    [ManualImportModuleName],
    [UserGranredAuthorityName.MANUAL_IMPORT],
    getTabName() + '| Manual import'
);

export default ManualImportModuleConfiguration;